import { AttachMoney, Build, TrendingUp } from "@mui/icons-material";
import { Card, CardContent, Grid, SxProps, Theme, Typography } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";

export const Solutions = () => {
  const solutions = [
    {
      title: "既存の運用に課題がある",
      description: "現在のシステム運用の非効率な部分を専門家の視点で改善します。",
      icon: Build,
    },
    {
      title: "まずは小さく試したい",
      description: "小規模からスタートし、効果を確認しながら段階的に拡大できます。",
      icon: TrendingUp,
    },
    {
      title: "コストを抑えたい",
      description: "必要な時に必要なだけ利用できる柔軟な契約形態でコスト効率を高めます。",
      icon: AttachMoney,
    },
  ];

  return (
    <SectionContainer sx={{ background: "#F8F9FA" }}>
      <SectionTitle>お客様の課題を解決します</SectionTitle>

      <Grid container spacing={4} sx={gridSx}>
        {solutions.map((solution, index) => {
          const IconComponent = solution.icon;
          return (
            <Grid item xs={12} md={4} key={index}>
              <Card sx={solutionCardSx}>
                <CardContent sx={cardContentSx}>
                  <IconComponent sx={iconSx} />
                  <Typography variant="h3" sx={solutionTitleSx}>
                    {solution.title}
                  </Typography>
                  <Typography variant="body1" sx={solutionDescriptionSx}>
                    {solution.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </SectionContainer>
  );
};

const gridSx: SxProps<Theme> = {
  justifyContent: "center",
};

const solutionCardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",
});

const cardContentSx: SxProps<Theme> = {
  padding: "40px",
  textAlign: "center",
};

const iconSx: SxProps<Theme> = (theme) => ({
  fontSize: "48px",
  marginBottom: "24px",
  color: "#22A1B9",
  backgroundColor: "#E8F4F8",
  borderRadius: "50%",
  padding: "16px",
  width: "80px",
  height: "80px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 24px auto",
});

const solutionTitleSx: SxProps<Theme> = (theme) => ({
  fontSize: "20px",
  fontWeight: 600,
  marginBottom: "16px",
  color: "#22A1B9",
});

const solutionDescriptionSx: SxProps<Theme> = {
  fontSize: "16px",
  lineHeight: 1.6,
  color: "#666666",
  textAlign: "left",
};
